export const getUniqueLinkFromUrl = () => {
  let link;
  const pathArray = window.location.pathname.split('/');
  if (pathArray?.length === 4 || pathArray?.length === 3) {
    link = pathArray[pathArray.length - 1];
  }
  return link;
};

export const getValidPrevPaymentsPath = (pathname: string) => {
  const pathContents = pathname.replace(/(^\/|\/$)/, '').split('/');
  let path = pathContents.slice(0, -1).join('/');
  if (pathContents.length <= 1) {
    path = 'payments/invoices';
  } else if (pathContents.length === 2) {
    path = pathContents.join('/');
  }
  return `/${path}`;
};
